'use client'
import { FC, useMemo } from 'react'
import { useCustomCart } from '#/src/custom/cart/useCustomCart'
import { StoreDTO } from 'ecosystem'
import { CheckoutPageStd, CheckoutStdPageConfig } from 'storefront-modules/checkout'
import { defaultImage } from '#/src/images'
import { useAppConfigContext } from '#/src/appConfig'

interface CheckoutPageComponentProps {
  store: StoreDTO
  initialData?: CheckoutStdPageConfig['initialData']
}

const CheckoutPageComponent: FC<CheckoutPageComponentProps> = ({ store, initialData }) => {
  const appConfig = useAppConfigContext()
  const cart = useCustomCart({ registerViewCartEvent: true })

  const config: CheckoutStdPageConfig = useMemo(() => {
    return {
      storeId: store.id,
      deliveryOptions: store.deliveries || [],
      pickupOptions: store.pickups || [],
      services: store.services || [],
      shippingConfig: appConfig.shippingProviderConfig,
      paymentProviderConfig: appConfig.paymentProviderConfig,
      cartTotalDiscount: cart.cartTotalDiscount,
      defaultCartImage: defaultImage,
      onApplyDiscountCode: cart.handleApplyDiscountCode,
      onRemoveDiscountCode: cart.handleRemoveDiscountCode,
      onAddToCart: cart.handleAddToCart,
      onRemoveFromCart: cart.handleRemoveFromCart,
      paths: {
        getDiscountCode: '/api/orders/get-discount-code',
        createOrder: '/api/orders/create-order',
        updateOrder: '/api/orders/update-order',
        updateDefaultShipment: '/api/orders/update-default-shipment'
      },
      onCheckout: cart.handleCheckout,
      onPurchase: cart.handlePurchase,
      initialData
    }
  }, [
    store.id,
    store.deliveries,
    store.pickups,
    store.services,
    cart.cartTotalDiscount,
    cart.handleApplyDiscountCode,
    cart.handleRemoveDiscountCode,
    cart.handleAddToCart,
    cart.handleRemoveFromCart,
    cart.handleCheckout,
    cart.handlePurchase,
    initialData,
    appConfig.shippingProviderConfig,
    appConfig.paymentProviderConfig
  ])

  return <CheckoutPageStd {...{ config }} />
}

export default CheckoutPageComponent
